import {useEffect} from "react";
import {useParams} from "react-router-dom";
import {useGetSubdivisionByCompanyIdQuery} from "../managementCompany";
import {DataTableColumn} from "../../../../components/common/datatable/DataTableTypes";
import {createClickableLink} from "../../../../components/common/datatable/DataTableUtils";
import {DataTable} from "../../../../components/common/datatable/DataTable";
import {useFindUserSettingsByGroupNameQuery} from "../../../../components/common/userSetting/userSettingsApi";

const Subdivision = () => {

    const {data: userSetting} = useFindUserSettingsByGroupNameQuery("Management Subdivision");
    let {companyId} = useParams();

    useEffect(() => {
        document.title = "Subdivisions"
    });

    const columns: DataTableColumn[] = [
        {
            label: "Name", accessor: "subdivisionName", visibility: {hasShowSetting: false},
            canSort: false,
            cell: (props: any) => {
                let path = "/subdivisions/" + props.row.original.id;
                return createClickableLink(path, props.value, userSetting);
            },
        },
        {
            label: "Association Name", accessor: "associationName", visibility: {hasShowSetting: false},
            canSort: false,
        },
        {
            label: "Association County",
            accessor: "associationCounty",
            visibility: {hasShowSetting: false},
            canSort: false,
        }
    ]


    return (

        <div className="">


            <div className="bg-text-0 border border-surface-5">
                <DataTable
                    columns={columns}
                    actions={{
                        fetchAction: useGetSubdivisionByCompanyIdQuery,
                    }}
                    defaultFilter={{
                        "managementCompanyId": companyId,
                        pageNumber: 0,
                        pageSize: 6
                    }}
                    defaultSortOptions={{
                        accessor: "creationDate",
                        direction: "asc",
                    }}
                    userSettingGroup={"Management Subdivision"}
                    appendFilterToUrl={false}
                    renderOptions={{skipUserSettingRender: true, skipPaginationRender: false}}
                    basePermission={"AUTOHOA"}
                    classname="bg-highlight-0 text-text-0 border-b border-surface-5"

                />
            </div>
        </div>
    );
}


export default Subdivision;